// extracted by mini-css-extract-plugin
module.exports = {"Home":"AdminHome_Home__lDqn4","lander":"AdminHome_lander__3TXrZ","Scrollable":"AdminHome_Scrollable__rs2Tn","TopButton":"AdminHome_TopButton__3NljV"};